import { databaseRef, functions } from 'config/firebase'
import { IRole } from 'types/database/users/user'

export const getCustomToken = functions.httpsCallable('getCustomToken')

export const getUserByEmail = async (email: string) => {
  const usersRecord = (
    await databaseRef
      .child('users')
      .orderByChild('email')
      .equalTo(email)
      .once('value')
  ).val()

  const users = Object.keys(usersRecord).map(key => ({
    ...usersRecord[key],
    id: key
  }))

  return users[0]
}

export const getUserById = async (id: string) => {
  try {
    const response = await databaseRef
      .child('users')
      .child(id)
      .once('value')
    return response.val()
  } catch (e) {
    console.log('Error => ', e)
    return null
  }
}

export const isEducator = (role: string | IRole | undefined) =>
  role === 'educator'

export const listenUser = (
  userId: string,
  onChange: (child: any) => void = () => {
    return
  },
  onError: (message: string) => void = () => {
    return
  }
): any => {
  try {
    const ref = databaseRef.child('users').child(userId)
    const f = ref.on('value', snapshot => snapshot && onChange(snapshot.val()))

    return () => ref.off('value', f)
  } catch (e) {
    if (e?.message) {
      onError(e.message)
    }

    return () => {
      return
    }
  }
}

export default {
  getUserByEmail,
  getUserById,
  listenUser
}



// WEBPACK FOOTER //
// ./src/services/user.ts